const Tools = require('./Tools.js');
const Promise = require('bluebird');
Promise.config({
	cancellation: true,
});

/**
 * Класс для управления pie-spinner
 */
class PieSpinner {
	constructor(config, debug = false) {
		this.config = config; //конфиг компонента
		this.debugMode = debug; //режим отладки

		this.pieSpinner = $('#pie-spinner'); //элемент спиннера
		this.pieSpinnerScratch = $('#pie-spinner-scratch'); //внешний круг с мар
		this.pieSpinnerDetailTextContainer = $('#pie-spinner-detail-text'); //контейнер для текстов

		if (this.pieSpinner.length && this.pieSpinnerDetailTextContainer.length) {
			this.pieSectors = this.pieSpinner.find('[data-sector-id]'); //сектора
			this.pieInnerTextItems = this.pieSpinner.find('[data-inner-text]'); //внутренние блоки текстов
			this.pieDetailTextItems = this.pieSpinnerDetailTextContainer.find('[data-sector-id]'); //блоки текстов

			this.lockPieClass = 'is-lock'; //класс для блокировки pie
			this.nullSectorClass = 'is-null-sector'; //класс для пустого сектора

			this.changeSectorTimeout = null; //переменная для таймаута переключения сектора

			this.bStopSpin = false;

			this.rotateNextPromise = false;

			//провешиваем кликина сектора
			this.initSectorsClickEvent();
			//выставляем первый активнй сектор
			//this.setActiveSector(this.pieSectors.first());
		}
	}

	/**
	 * Биндер кликов по секторам
	 */
	initSectorsClickEvent() {
		this.pieSectors.each((key, sector) => {
			let $sector = $(sector);

			$sector.on('click', (e) => {
				if ($sector.hasClass('is-active')) {
					return false;
				}

				this.rotateNext($sector);
				return false;
			});
		});
	}

	/**
	 * Возвращает текущий активный сектов
	 */
	getActiveSector() {
		if (this.pieSectors.length) {
			return this.pieSectors.filter((key, item) => {
				return $(item).hasClass('is-active');
			});
		} else {
			if (this.debugMode) {
				Tools.log('PieSpinner: getActiveSector', 'Не найдены элементы pie');
			}
		}
	}

	/**
	 * Возвращает блок текста для сектора по его ID
	 * @param sectorID - id сектора
	 */
	getDetailTextBlockBySectorID(sectorID) {
		if (this.pieDetailTextItems.length) {
			return this.pieDetailTextItems.filter((key, item) => {
				return $(item).attr(`data-sector-id`) == sectorID;
			});
		} else {
			if (this.debugMode) {
				Tools.log('PieSpinner: getDetailTextBlockBySectorID', 'Не найден блок текста');
			}
		}
	}

	/**
	 * Деактивировать активный сектовр
	 * @returns {Promise.<TResult>}
	 */
	disableActiveSector() {
		return Promise.resolve()
			.then(() => {
				//взять текущий активный сектор
				const $activeSector = this.getActiveSector();

				if ($activeSector.length) {
					const sectorID = $activeSector.attr('data-sector-id'); //id сектора
					const $detailText = this.getDetailTextBlockBySectorID(sectorID); //взять блок текста для переданного ID сектора

					$detailText.velocity('stop');
					return $.Velocity($detailText, {
						width: '0',
						opacity: '0',
					}, this.config['pieArrowFadeSpeed'])
						// .then(() => {
						// 	return $.Velocity(this.pieInnerTextItems, 'fadeOut', this.config['pieInnerTextFadeSpeed']);
						// })
						.then(() => {
							//снимаем признак активности с сектора
							$activeSector.removeClass('is-active');
						});
				} else {
					throw 'Не найдены активный элемент';
				}
			})
			.catch((e) => {
				// if (this.debugMode) {
				// 	Tools.log('PieSpinner: disableActiveSector', e);
				// }
			});
	}

	/**
	 * Выставить активность сектору
	 * @param $sector - сектор для манипуляций
	 * @returns {Promise.<TResult>}
	 */
	setActiveSector($sector) {
		return Promise.resolve()
			.then(() => {
				if ($sector.length) {
					const sectorAngle = $sector.attr('data-angle');//угол поворота
					const spinAngle = this.getRotateAngle(sectorAngle);//угол поворота
					const sectorID = $sector.attr('data-sector-id'); //id сектора
					const $detailText = this.getDetailTextBlockBySectorID(sectorID); //детальный текст для сектора

					clearTimeout(this.changeSectorTimeout);

					//выставляем класс активности
					$sector.addClass('is-active');

					return Promise.resolve()
						.then(() => {
							if ($sector.hasClass(this.nullSectorClass)) {
								return $.Velocity(this.pieSpinnerScratch, {
									opacity: '0',
								}, this.config['pieArrowFadeSpeed']);
							}
						})
						.then(() => {
							//поворачиваем круг
							return $.Velocity(this.pieSpinnerScratch, {
								rotateZ: `+=${spinAngle}deg`,
							}, this.config['pieSpinSpeed']);
						})
						// .then(() => {
						// 	return this.rotateInnerTextBlock();
						// })
						// .then(() => {
						// 	return this.setSectorsPosition();
						// })
						// .then(() => {
						// 	return $.Velocity(this.pieInnerTextItems, 'fadeIn', this.config['pieInnerTextFadeSpeed']);
						// })
						.then(() => {
							if (!$sector.hasClass(this.nullSectorClass)) {
								return $.Velocity(this.pieSpinnerScratch, {
									opacity: '1',
								}, this.config['pieArrowFadeSpeed']);
							}
						})
						.then(() => {
							//показываем текст
							return $.Velocity($detailText, {
								width: '100%',
								opacity: '1',
							}, this.config['pieArrowFadeSpeed']);
						})
						.then(() => {
							if (!this.bStopSpin) {
								this.changeSectorTimeout = setTimeout(() => {
									this.rotateNext();
								}, this.config['pieRotateNextSpeed']);
							}
						});
				}
			})
			.catch((e) => {
				if (this.debugMode) {
					Tools.log('PieSpinner: setActiveSector', e);
				}
			});
	}

	/**
	 * Переключение сектора на следующий в блоке, либо на переданный параметром
	 * @param $sector - сектор, на который нужно переключить
	 * @returns {boolean}
	 */
	rotateNext($sector = null, force = false) {
		return new Promise((resolve, reject) => {
			//если pie блокирован, то выходим
			if (!this.isLockPie() || force) {
				let $targetSector = null;

				//если передан сектор, то целевым ставим его
				if ($sector && $sector.length) {
					$targetSector = $sector;
				} else {
					$targetSector = this.getPrevSector();
				}

				//блокируем pie
				this.lockPie();

				this.onBeforeRotateNext($targetSector);

				//тормозим запушеный промис смены сектора
				//нужно в случае перехода по хешу, например.
				if (force) {
					this.rotateNextPromise.cancel();
				}
				//деактивируем активнй сектов
				this.rotateNextPromise = this.disableActiveSector()
					.then(() => {
						//ставим активным текущий сектов
						return this.setActiveSector($targetSector);
					})
					.then(() => {
						this.unlockPie();
						this.onAfterRotateNext($targetSector);
						resolve();
					});
			}
		});
	}

	/**
	 * Возвращает предыдущий сектор относительно активного
	 * @returns {*}
	 */
	getPrevSector() {
		let $prevSector = null;
		//берем текущий активный сектор
		const $currentItem = this.getActiveSector();
		//берем следующий элемент из потока
		$prevSector = $currentItem.prev();

		//если текущий элемент был последним в блоке
		if (!$prevSector.length) {
			//берем первый элемент
			$prevSector = this.pieSectors.last();

			//дергаем коллбек автоматического прохождения полного круга
			this.onAutoFullSpinCompleted();
		} else if ($prevSector.hasClass(this.nullSectorClass)) {
			//дергаем коллбек достижения нулевого элемента
			this.onAutoSpinToNullItemCompleted();
		}

		return $prevSector;
	}

	/**
	 * Поворот текста относительно поворота всего круга
	 * @returns {Promise.<TResult>}
	 */
	rotateInnerTextBlock() {
		return Promise.resolve()
			.then(() => {
				if (this.pieInnerTextItems.length) {
					let currentPieRotateValue = Tools.getRotationDegrees(this.pieSpinner);

					return $.Velocity(this.pieInnerTextItems, {
						rotateZ: `-${currentPieRotateValue}deg`,
					}, 0);
				} else {
					throw 'Не найдены блоки внутреннего текста';
				}
			})
			.catch(e => {
				if (this.debugMode) {
					Tools.log('PieSpinner: rotateInnerTextBlock', e);
				}
			});
	}

	setSectorsPosition() {
		return Promise.resolve()
			.then(() => {
				if (this.pieSectors.length) {
					this.pieSectors.each((i, sector) => {
						const $sector = $(sector);
						const sectorAngle = $sector.attr('data-angle');//изначальный угол элемента
						const pieSpinValue = Tools.getRotationDegrees(this.pieSpinner);//угол проворта всего круга

						$sector.attr('data-position', this.getItemPosition(sectorAngle, pieSpinValue));
					});
				} else {
					throw 'Не найдены сектора';
				}
			})
			.catch(e => {
				if (this.debugMode) {
					Tools.log('PieSpinner: setSectorsPosition', e);
				}
			});
	}

	/**
	 * Возвращают угол, на который нужно провернуть pie для того, что элемент встал в нулевую позицию
	 * @param itemDeg - угол сектора, который нужно выставить в активное состояни
	 * @returns {number}
	 */
	getRotateAngle(itemDeg = 0) {
		let currentPieRotateValue = Tools.getRotationDegrees(this.pieSpinnerScratch);
		let surpluseValue = currentPieRotateValue % 360;

		let angle = (360 - surpluseValue - Number(itemDeg));
		if (angle > 0) {
			angle += -360;
		}

		return angle;
	}

	/**
	 * Возвращает номер позиции элемента для переданного проворта круга
	 * @param itemDeg
	 * @param currentPieRotateValue
	 * @returns {number}
	 */
	getItemPosition(itemDeg = 0, currentPieRotateValue = 0) {
		return (((Number(itemDeg) + currentPieRotateValue) % 360) / (360 / this.pieSectors.length));
	}

	/**
	 * Возвращает количество секторов
	 */
	getSectorsCount() {
		return this.pieSectors.length;
	}

	/**
	 * Останавливает анимацию
	 */
	stopSpin() {
		clearTimeout(this.changeSectorTimeout);
		this.bStopSpin = true;
	}

	/**
	 * Запустить анимацию
	 */
	startSpin() {
		clearTimeout(this.changeSectorTimeout);
		this.bStopSpin = false;
		this.changeSectorTimeout = setTimeout(() => {
			this.rotateNext();
		}, this.config['pieRotateNextSpeed']);
	}

	/**
	 * Перезапуск pie-диаграммы
	 * @returns {Promise.<TResult>}
	 */
	reset() {
		return Promise.resolve()
			.then(() => {
				this.bStopSpin = false;
				this.rotateNext(this.pieSectors.first());
			});
	}

	/**
	 * Получить хэш для текущего активного сектора
	 * @returns {*}
	 */
	getHashByCurrentSector() {
		const $activeSector = this.getActiveSector();
		return $activeSector.attr('data-sector-hash');
	}

	/**
	 * Возвращает ID сектора по его хешу.
	 * @param addressHash - целевой хэш
	 * @returns {int} | {boolean}
	 */
	getSectorByHash(addressHash) {
		let $targetSector = this.pieSectors.filter((key, item) => {
			let sectorHash = $(item).attr(`data-sector-hash`);

			return (sectorHash == addressHash)
				? true
				: (sectorHash == '#' + addressHash);
		});

		return ($targetSector.length) ? $targetSector : false;
	}

	/**
	 * Переход к сектору по его хешу
	 * @param addressHash
	 */
	goToSectorByHash(addressHash) {
		return Promise.resolve()
			.then(() => {
				let sector = this.getSectorByHash(addressHash);
				if (sector) {
					return this.rotateNext(sector, true);
				}
			});
	}

	/**
	 * Выставить state блокировки на Pie
	 */
	lockPie() {
		this.pieSpinner.addClass(this.lockPieClass);
	}

	/**
	 * Снять state блокировки на Pie
	 */
	unlockPie() {
		this.pieSpinner.removeClass(this.lockPieClass);
	}

	/**
	 * Проверить, заблокирован ли Pie
	 * @returns {*}
	 */
	isLockPie() {
		return this.pieSpinner.hasClass(this.lockPieClass);
	}

	/**
	 * Callback автоматичекого прохождения полного цикла
	 */
	onAutoFullSpinCompleted() {

	}

	/**
	 * Callback автоматичекого достижения нулевого элемента
	 */
	onAutoSpinToNullItemCompleted() {

	}

	/**
	 *  Callback переда началом процесса перехода на следующий слайд
	 * @param $targetSector - сектор, на который будет переход
	 */
	onBeforeRotateNext($targetSector) {

	}

	/**
	 *  Callback после начала процесса перехода на следующий слайд
	 * @param $targetSector - сектор, на который будет переход
	 */
	onAfterRotateNext($targetSector) {

	}
}

module.exports = PieSpinner;



// WEBPACK FOOTER //
// ./temp/components/mainpage/classes/PieSpinner.js